import React from 'react'

import { Select, SearchInput } from 'sw-components'
import type { DropdownProps } from 'sw-components'


type Fields = {
  search: string
  sort: string
}

export type SortAndSearchProps = {
  withSearch: boolean
  sortForm: Forms.Form<Fields>
  sortOptions: DropdownProps['options']
  onSearchFocus?: () => void
}

const SortAndSearch: React.FC<SortAndSearchProps> = (props) => {
  const { withSearch, sortForm, sortOptions, onSearchFocus } = props

  return (
    <div className="flex items-center">
      {
        withSearch && (
          <SearchInput
            field={sortForm.fields.search}
            onFocus={onSearchFocus}
          />
        )
      }
      <Select
        className="ml-24"
        options={sortOptions}
        placement="bottom-end"
        field={sortForm.fields.sort}
      />
    </div>
  )
}


export default React.memo(SortAndSearch)
